import React from 'react';
import LoaderHolder from './LoaderHolder';
import { LoaderHolderProps } from '../type';
import './LineStyle.scss';

function LineStyle(props: LoaderHolderProps) {
  return (
    <LoaderHolder
      className="elmo-loader-line"
      viewBoxHeight={35}
      viewBoxWidth={500}
      {...props}
    >
      <rect x="0" y="10" rx="4" ry="4" width="500" height="25" />
    </LoaderHolder>
  );
}

export default LineStyle;
